document.addEventListener('DOMContentLoaded', function () {
  const ymalSwiper = new Swiper('.ymal-swiper', {
    slidesPerView: 4.5,
    slidesPerGroup: 4,
    loop: false,
    pagination: {
      el: '.ymal-pagination',
      clickable: true
    },

    navigation: {
      nextEl: '.ymal-next',
      prevEl: '.ymal-prev'
    },

    grabCursor: true,

    breakpoints: {
      0: {
        slidesPerView: 1.2,
        slidesPerGroup: 1,
        spaceBetween: 17
      },
      768: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 30
      },
      1250: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 38
      }
    }
  });
});
